import { services } from '../../../mocks/britfit';

export default function Services() {
  return (
    <section id="services" className="bg-[#F8F7F4] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block bg-white text-[#1B4332] text-xs font-semibold px-4 py-1.5 rounded-full border border-stone-200 mb-4">
              Our Services
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-stone-900 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
              Everything Your Vehicle<br />
              Needs, Wherever You Are
            </h2>
          </div>
          <p className="text-stone-500 text-sm leading-relaxed max-w-xs md:text-right">
            Fully equipped mobile units — we carry everything needed to complete the job at your location.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Wide card */}
          <div className="md:col-span-1 bg-white rounded-2xl overflow-hidden cursor-pointer group">
            <div className="h-52 overflow-hidden">
              <img
                src={services[0].image}
                alt={services[0].title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <div className="w-9 h-9 flex items-center justify-center bg-[#E8F5EE] rounded-xl mb-4">
                <i className={`${services[0].icon} text-[#1B4332] text-lg`} />
              </div>
              <h3 className="text-lg font-bold text-stone-900 mb-2" style={{ fontFamily: 'Syne, sans-serif' }}>
                {services[0].title}
              </h3>
              <p className="text-stone-500 text-sm leading-relaxed">{services[0].description}</p>
              <div className="mt-4 flex items-center gap-1 text-[#1B4332] text-sm font-medium cursor-pointer">
                Learn more <i className="ri-arrow-right-line" />
              </div>
            </div>
          </div>

          {/* Right side 2x2 grid */}
          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {services.slice(1).map((service) => (
              <div
                key={service.id}
                className="bg-white rounded-2xl overflow-hidden cursor-pointer group"
              >
                <div className="h-40 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#E8F5EE] rounded-xl mb-3">
                    <i className={`${service.icon} text-[#1B4332] text-base`} />
                  </div>
                  <h3 className="text-base font-bold text-stone-900 mb-1.5" style={{ fontFamily: 'Syne, sans-serif' }}>
                    {service.title}
                  </h3>
                  <p className="text-stone-500 text-xs leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
